export const mapScriptConstants = {
    MAP_SCRIPT_REQUEST: 'MAP_SCRIPT_REQUEST',
    MAP_SCRIPT_SUCCESS: 'MAP_SCRIPT_SUCCESS',
    MAP_SCRIPT_FAILURE: 'MAP_SCRIPT_FAILURE'
}